module.exports = __webpack_public_path__ + "static/media/loginpic5.5fa96cb1.jpeg";